import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './ClientInfo.scss';
import { useSelector } from 'react-redux';
import ReturnInfoTile from '../../../components/returns/ReturnInfoTile';

const PurchaseYearSection = (props) => {
    const [sortedReturns, setSortedReturns] = useState([]);

    const lang = useSelector(state => state.layout.lang)

    useEffect(() => {
        if (props.returns && props.returns.length === 0) {
            setSortedReturns([])
        } else {
            setSortedReturns([...props.returns].sort((a, b) => {
                const aDate = new Date(a.lastModified)
                const bDate = new Date(b.lastModified)
                return bDate.getTime() - aDate.getTime()
            }) || [])
        }

    }, [props.returns]);

    return sortedReturns && sortedReturns.length > 0 ? (
        <Fragment>
            <div className='columns separator-border purchase-year-header'>
                <div className='column is-1' />
                <div className='column is-10'>
                    <h4>{props.taxYear}</h4>
                    <hr />
                </div>
                <div className='column is-1' />
            </div>
            {sortedReturns.map((r,idx) => (
                <ReturnInfoTile key={`rit_${idx}`} return={r} clientId={props.clientId} lang={lang}/>
            ))}
        </Fragment>
    ) : null;
}

PurchaseYearSection.propTypes = {
    taxYear: PropTypes.number.isRequired,
    returns: PropTypes.arrayOf(PropTypes.object),
    clientId: PropTypes.string
}

export default PurchaseYearSection;